import React, { useState, useEffect } from 'react';
import { useNavigate }               from 'react-router-dom';
import { login }                     from '../auth';
import axios                         from 'axios';
import logo                          from '../assets/proload_220.png';
import { API_BASE_URL, GIT_SHA  }    from '../config';

export default function Login() {
  const [username, setUsername]     = useState('');
  const [password, setPassword]     = useState('');
  const [error, setError]           = useState('');
  const [apiVersion, setApiVersion] = useState(null);
  const navigate                     = useNavigate();

  // grab API version
  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/version`, { responseType: 'text' })
      .then(res => setApiVersion(res.data.trim()))
      .catch(err => {
        console.error('Failed to fetch API version', err);
        setApiVersion('N/A');
      });
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    try {
      // trim whitespace
      await login({
        username: username.trim(),
        password: password.trim()
      });
      navigate('/usage-summary', { replace: true });
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <img src={logo} alt="Proload Logo" style={styles.logo} />
        <h1 style={styles.title}>Proload Dashboard</h1>

        {error && <div style={styles.error}>{error}</div>}

        <form
          onSubmit={handleSubmit}
          style={styles.form}
          autoComplete="on"
        >
          <input
            style={styles.input}
            type="text"
            name="username"
            placeholder="Username"
            autoComplete="username"
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            name="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">
            Log In
          </button>
        </form>

        <div style={styles.versions}>
          <small>React: {GIT_SHA || 'unknown'}</small><br/>
          <small>API: {apiVersion || 'Loading…'}</small>
        </div>
      </div>
    </div>
  );
}

// simple inline styles
const styles = {
  page: {
    minHeight: '100vh',
    display:   'flex',
    alignItems:    'center',
    justifyContent:'center',
    background:    '#f7f9fc'
  },
  card: {
    width:        360,
    padding:      24,
    borderRadius: 8,
    boxShadow:    '0 4px 12px rgba(0,0,0,0.1)',
    background:   '#fff',
    textAlign:    'center'
  },
  logo: {
    width:  80,
    margin: '0 auto 16px'
  },
  title: {
    margin:       '0 0 24px',
    fontSize:     '1.5rem',
    color:        '#333'
  },
  error: {
    margin:       '0 0 16px',
    color:        'red',
    fontSize:     '0.9rem'
  },
  form: {
    display:      'flex',
    flexDirection:'column',
    gap:          '12px'
  },
  input: {
    padding:      '10px 12px',
    fontSize:     '1rem',
    borderRadius: 4,
    border:       '1px solid #ccc',
    outline:      'none',
    transition:   'border-color 0.2s',
  },
  button: {
    padding:      '10px 12px',
    fontSize:     '1rem',
    borderRadius: 4,
    border:       'none',
    background:   '#0078d4',
    color:        '#fff',
    cursor:       'pointer',
    transition:   'background 0.2s'
  },
  versions: {
    marginTop:    16,
    color:        '#666',
    fontSize:     '0.8rem',
    lineHeight:   1.4
  }
};
